import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import RedirectToApp from './components/RedirectToApp';
import AdminDashboard from './components/AdminDashboard';
import AdminTest from './components/AdminTest';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';
import ReleaseNotesPage from './pages/admin/ReleaseNotesPage';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Login route - accessible without authentication */}
          <Route path="/login" element={<Login />} />
          
          {/* Redirect from root to /app with loading component */}
          <Route path="/" element={<RedirectToApp />} />
          
          {/* Protected routes */}
          <Route path="/app" element={
            <ProtectedRoute>
    <App />
            </ProtectedRoute>
          } />
          
          {/* Admin routes - require authentication and admin role */}
          <Route path="/admin" element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
          
          <Route path="/admin/test" element={
            <AdminRoute>
              <AdminTest />
            </AdminRoute>
          } />
          
          <Route path="/admin/release-notes" element={
            <AdminRoute>
              <ReleaseNotesPage />
            </AdminRoute>
          } />
          
          {/* Catch all other routes and redirect to /app */}
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);
